import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import Spinner from "../common/Spinner";

function HamlSnippet({ url }) {
  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const containerRef = useRef(null);
  const history = useHistory();

  useEffect(() => {
    fetch(url, { headers: { "Accept": "text/html" } })
      .then(res => res.text())
      .then(data => {
        setHtml(data);
        setLoading(false);
      });
  }, [url]);

  useEffect(() => {
    if (!html) return; // nothing to attach yet

    const timeout = setTimeout(() => {
      const container = containerRef.current;
      if (!container) return;

      const handleClick = (e) => {
        const link = e.target.closest("a");
        if (!link) return;
        if (!link.classList.contains('page-link')) return;

        const href = link.getAttribute("href");
        const isInternal = href && href.startsWith("/") && !href.startsWith("//");

        if (isInternal) {
          e.preventDefault();
          history.push(href); // or navigate(href);
        }
      };

      container.addEventListener("click", handleClick);
      return () => container.removeEventListener("click", handleClick);
     }, 0); // next tick, after render

    return () => clearTimeout(timeout);
  }, [history, html]);

  if (loading) return <Spinner identifier = "bigbox"/>;

  return <div ref={containerRef} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default HamlSnippet;